import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import styles from "./ImmunizationCovidViewNew.module.css";

import { AddButton, InputBox, Modal, Button } from "@cpnw/ui";
import DashboardRadio from "components/DashboardRadio";
import FormDatePicker from "components/FormDatePicker";
import classNames from "classnames";
import { DATE_FORMAT_PATTERN } from "pages/enums";

// const SubmissionTypes = {
//   Military: "Military",
//   A: "A",
//   B: "B",
// };

// const SubmissionTypeDescriptions = {
//   Military: "Military immunization",
//   A: "A. Vaccination Dates:",
//   B: "B. Immunity by Titer:",
// };

const Results = {
  Neg: "Neg",
  Pos: "Pos",
};

export const ImmunizationCovidViewNew = forwardRef(({ data, onChange, disabled = false }, ref) => {
  const [isNotificationModalOpen, setNotificationModalOpen] = useState(false);
  const [notificationContent, setNotificationContent] = useState("");
  const [na, setNa] = useState(false);

  const setValue = (key, value) => {
    const updated = { ...data, [key]: value };
    if (onChange) {
      onChange(updated);
    }
  };

  useImperativeHandle(ref, () => ({
    validator: () => {
      // Clean manufacturer (remove if empty or all spaces)
      // if (typeof data.manufacturer === "string") {
      //   const m = data.manufacturer.trim();
      //   if (m) {
      //     data.manufacturer = m;
      //   } else {
      //     delete data.manufacturer;
      //   }
      // }

      // Clean boosterList: remove empty entries
      const boosters = data.boosterList?.boosterList || [];
      const cleanedBoosters = boosters
        .map((entry) => ({
          ...entry,
          manufacturer: typeof entry.manufacturer === "string"
            ? entry.manufacturer.trim()
            : entry.manufacturer,
        }))
        .filter((entry) => entry.date || entry.manufacturer);

      if (cleanedBoosters.length > 0) {
        data.boosterList = { boosterList: cleanedBoosters };
      } else {
        delete data.boosterList;
      }

    },

    clear: () => {
      setNa(false); // reset UI
      onChange({}); // reset external data
    }
  }));

  const ensureTypePath = (type) => {
    if (!data[type]) data[type] = {};
  };

  const updateEntry = (field, index, key, value) => {
    const booster = data.boosterList?.[field] || [];
    const updatedList = [...booster];

    updatedList[index] = {
      ...updatedList[index],
      [key]: value,
    };

    const updated = {
      ...data,
      boosterList: {
        ...(data.boosterList || {}),
        [field]: updatedList,
      },
    };

    if (onChange) {
      onChange(updated);
    }
  };

  const addEntry = (field) => {
    const updatedList = [
      ...(data.boosterList?.[field] || []),
      { date: "", result: "", manufacturer: "" }
    ];

    const updated = {
      ...data,
      boosterList: {
        ...(data.boosterList || {}),
        [field]: updatedList
      }
    };

    if (onChange) {
      onChange(updated);
    }
  };

  const removeEntry = (field, index) => {
    const updatedList = [...(data.boosterList?.[field] || [])];
    updatedList.splice(index, 1);

    const updated = {
      ...data,
      boosterList: {
        ...(data.boosterList || {}),
        [field]: updatedList,
      },
    };

    if (onChange) {
      onChange(updated);
    }
  };

  // Handle Dismiss click:
  const handleCloseNotification = (message) => {
    setNotificationContent("")
    setNotificationModalOpen(false)
  };

  useEffect(() => {
    console.log('datadatadata', data)
    setNa(data.na || false);
  }, [data]);

  return (
    <div className={classNames(styles.container, styles.lv0)}>
      <div className={classNames(styles.testGroup)}>
        <div className={styles.testColumn}>
          <div className={styles.testRow}>
            <div className={classNames(styles.testItem)}>
              <div className={styles.datePickerContainer}>
                <span className={styles.w100}>NA Check Box:</span>
                <div className={classNames(styles.testItem)}>
                  <CheckboxItem
                    className={styles.checkbox}
                    isChecked={na}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setNa(checked);
                      setValue("na", checked);

                      if (checked) {
                        setNotificationModalOpen(true);
                      }
                    }}
                  // label="I have no record of receiving a COVID-19 vaccine or booster"
                  // description="Check this if you’ve never received a COVID-19 vaccine or booster."
                  />
                </div>

              </div>
            </div>
          </div>
          {/* <div className={styles.testRow}>
            <div className={classNames(styles.testItem)}>
              <div className={styles.datePickerContainer}>
                <span className={styles.w100}>Manufacturer:</span>
                <InputBox
                  placeholder={""}
                  onChange={(e) => {
                    data.manufacturer = e.target.value;
                    setValue();
                  }}
                  value={data.manufacturer}
                  disabled={disabled}
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <BoostersContent
        field="boosterList"
        label="Dose: "
        data={data}
        typeKey="boosterList"
        updateEntry={updateEntry}
        addEntry={addEntry}
        removeEntry={removeEntry}
        disabled={disabled}
      />
      {isNotificationModalOpen ? <Modal
        isOpen={isNotificationModalOpen}
        onRequestClose={() => {
          handleCloseNotification(true)
        }}
        className={classNames([styles.notificationModal])}
      >
        <h3>Notification</h3>
        <div className={styles.notificationContent}>
          You’ve selected that you have no record of receiving a COVID-19 vaccine or booster.
          Please be aware that some clinical sites or programs may require COVID-19 vaccination for participation.
          To prevent any delays with your clinical placement, be sure to follow up with your program coordinator for guidance on next steps.
        </div>

        <div className={styles.closeButton}>
          <Button
            text={"OK"}
            type={"submit"}
            className={styles.customButton}
            onClick={(ev) => {
              handleCloseNotification(true)
            }}
          />
        </div>
      </Modal> : undefined}
    </div>
  );
});

function BoostersContent({ field, label, data, typeKey, updateEntry, addEntry, removeEntry, disabled }) {
  const ALLOW_ADD_MORE = true;
  const dateList = data[typeKey]?.[field] || [];

  // Initialize first date if list is empty
  useEffect(() => {
    if (!disabled && dateList.length === 0) {
      addEntry(field);
      addEntry(field);
    }
  }, [dateList, field, addEntry, disabled]);

  return (
    <div className={classNames(styles.testGroup)}>
      {dateList.map((entry, index) => (
        <div key={index} className={styles.testColumn}>

          <div className={styles.testRow}>
            <div className={classNames(styles.testItem)}>
              <div className={styles.datePickerContainer}>
                <span className={styles.w100}>Manufacturer:</span>
                <InputBox
                  placeholder=""
                  onChange={(e) => updateEntry(field, index, "manufacturer", e.target.value)}
                  value={entry.manufacturer || ""}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>


          <div key={index} className={styles.testRow}>
            <div className={classNames(styles.testItem)}>
              <LabeledDatePicker
                label={`Dose ${index + 1}. `}
                dateString={entry.date}
                onChange={(value) => updateEntry(field, index, "date", value)}
                disabled={disabled}
              />
            </div>
            <div className={classNames(styles.testItem, styles.lv2)}>
              {/* <ResultRadioGroup
                name={`${field}-result-${index}`}
                value={entry.result}
                onChange={(val) => updateEntry(field, index, "result", val)}
                disabled={disabled}
              /> */}
              {!disabled && ALLOW_ADD_MORE && (
                <button
                  type="button"
                  onClick={() => removeEntry(field, index)}
                  className={styles.removeButton}
                  aria-label="Remove"
                >
                  x
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
      {!disabled && ALLOW_ADD_MORE && (
        <AddButton onClick={() => addEntry(field)} label="Add Booster" />
      )}
    </div>
  );
}

function LabeledDatePicker({ label, dateString, onChange, disabled }) {
  return (
    <div className={styles.datePickerContainer}>
      <span className={styles.w100}>{label}</span>
      <FormDatePicker
        dateFormat={DATE_FORMAT_PATTERN}
        dateString={dateString}
        setDate={onChange}
        disabled={disabled}
      />
    </div>
  );
}

function ResultRadioGroup({ name, value, onChange, disabled }) {
  return (
    <div className={classNames(styles.resultContainer)}>
      <span>Result:</span>
      {Object.values(Results).map((result) => (
        <div key={result} className={classNames(styles.radios)}>
          <DashboardRadio
            name={name}
            isSelected={value === result}
            onChange={() => onChange(result)}
            value={result}
            label={result}
            containerClassName={styles.radioContainer}
            disabled={disabled}
          />
        </div>
      ))}
    </div>
  );
}

function CheckboxItem({ isChecked, onChange }) {
  return (
    <input type="checkbox" checked={isChecked} onChange={onChange} />
  );
}
